export default __webpack_public_path__ + "static/app-store-download@2x-c0dfa664804069713c7ecbc408cc7b38.png";